import { logNavInteraction, NAV_ELEMENT_TYPES, NAV_ACTIONS } from 'utils';

export default function NewsletterForm({signupFormLocation, navInteractionConfig}) {
    return (
        <>
            <div className='tw-mb-24 tw-flex tw-flex-col tw-gap-4'>
                <h4 className="tw-text-24 tw-font-bold tw-text-[#00A3E0]">Never Miss a Drop!</h4>
                <p className="tw-text-14 tw-text-[#6B7280]">Sign up to be first to receive the latest Cirkul news!</p>
            </div>
            <form data-abide data-newsletter-signup-form={signupFormLocation}>
                <label for="email" class="hide">Email Address</label>
                <div class="tw-flex tw-flex-col tw-gap-16 desktop:tw-flex-row">
                    <input
                        onClick={(e) => e.stopPropagation()}  
                        className="tw-mb-0 !tw-rounded-4 tw-border-none tw-bg-[#F3F3F7]"
                        name="emailAddress"
                        type="email"
                        id="email"
                        placeholder="example@email.com"
                        required
                    />
                    <div class="input-group-button">
                        <button onClick={() => logNavInteraction({
                            ...navInteractionConfig,
                            order: 1, 
                            elementType: NAV_ELEMENT_TYPES.BUTTON, 
                            text: 'Submit', 
                            action: NAV_ACTIONS.SUBMIT,
                        })} 
                        type="submit" className="tw-h-fit tw-w-full !tw-rounded-4 tw-bg-[#00A3E0] tw-px-[26px] tw-py-[17px] tw-text-14 tw-font-bold tw-leading-16 tw-text-white tw-outline-[#005EB8] hover:tw-bg-[#29C5FF] focus:tw-bg-[#00A3E0] active:tw-bg-[#0072A6] disabled:tw-bg-[#AFB6B4]">
                            Submit
                        </button>
                    </div>
                </div>
            </form>
            <p class="tw-my-10 tw-text-10 tw-leading-[11px] tw-text-[#6B7280]">By signing up, you agree to receive Cirkul news and offers via email.</p>
        </>
    )
}
